<template>
  <v-layout :class="containerStyle"
            justify-start
            fill-height
            column>
    <v-flex align-self-center
            shrink>
      <div :class="$style.title">
        {{ title }}
      </div>
    </v-flex>
    <v-flex>
      <v-layout justify-center>
        <slot/>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Provide layout and styles from nested menu item
 */
@Component({
  props: {
    title:    String,
    badge:    String,
    platform: String,
  },
})
export default class NestedMenu extends Vue {
  get containerStyle() {
    const styles = [this.$style.content];

    if (this.platform === 'kiosk') {
      styles.push(this.$style.kiosk);
    } else {
      styles.push(this.$style.web);
    }

    return styles;
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
.kiosk {
  padding-top: 16%;
  display: flex;
  flex-direction: column;
  height: calc(100vh - #{$kioskHeaderHeight});
  min-height: calc(1920px - #{$kioskHeaderHeight});
  flex: 1 1 0;
  position: relative;

  .title {
    @media screen and (min-width: $mobile-breakpoint-max + 1)
      and (max-width: $kiosk-breakpoint-max) {
            font-size: 60px;
            line-height: 70px;
          }
      }
}

.web {
  padding: 5% 0;
}

.content {
  background: $white;

  .title {
    margin: 70px 20px 60px;
    text-transform: uppercase;
    font-family: 'Gotham', sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    text-align: center;
  }

  @media screen and (max-width: $mobile-breakpoint-max) {
    padding: 30px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/NestedMenu.vue